import type { WebSocketOptions } from "@/constants/interfaces";
import { defineStore } from "pinia";
import { ref, shallowRef } from "vue";
import { EventBus } from "@/assets/services/eventbus";
import {  SenderType, WebSocketUpdateMessage, WidgetList } from "@/constants/common-constants";
import { uuid } from "vue-uuid";
import { useGlobalStore } from "./globalStore";
import { currentEstTime } from "@/utilities/utilities";

export const useChatMessageInfo = defineStore('useChatMessageInfo' ,()=>{
   const ChatMessageDetails = ref<{}[]>([])
   const LiveAgentChatMessageDetails = ref<{}[]>([])
   const ConversationId = ref<number|string>(0)
   const ChatNewSessionId = ref<string>("")
   const ChatOldSessionId = ref<string>("")
   const ChatCallFrom = ref<string>('NewChat')
   const ChatLiveAgentDetails = ref<Record<string,string>>({})
   const ContactDetails = ref<Record<string, string>>({});
   const ConversationDetails = ref<Record<string, string>>({});
   const DomSnapBase64Image = ref<string>("")

   function ClearChatDetails(){
    LiveAgentChatMessageDetails.value = []
    ChatMessageDetails.value = []
   }

    //#region Websocket 
    
   // Reactive state for WebSocket connection
   const socket = shallowRef<WebSocket | null>(null)
   const isSocketConnected = ref(false)
   const data = shallowRef<any>(null)
   const error = shallowRef<Error | null>(null)
 
   // Reconnection tracking
   let currentReconnectAttempt = 0
 
   // Create WebSocket connection
   function socketConnect(options:WebSocketOptions) {
    const {
      url,
      protocols,
      reconnectAttempts = 5,
      reconnectTimeout = 3000
    } = options
     try {
       socket.value = new WebSocket(url)
       const {ActiveComponent,NotificationCount,ChatCommandCommunication} = useGlobalStore()

 
       // Connection opened
       socket.value.onopen = () => {
         isSocketConnected.value = true
         currentReconnectAttempt = 0
        //  EventBus.emit('open')
        //  console.log('WebSocket connection established')
       }
 
       // Listen for messages
       socket.value.onmessage = (event) => {
         try {
           const parsedData = JSON.parse(event.data)
        //    console.log(parsedData)
          if(ActiveComponent.value == WidgetList.AIChatBot)
          {
            
            // Emit the message to the event bus
            EventBus.emit('message', parsedData)
          }
          else
          {
            const messageData = parsedData?.message?.data;
            if (parsedData?.message?.event === WebSocketUpdateMessage.MessageCreated) {
            LiveAgentChatMessageDetails.value.push({
              createdAt: currentEstTime.value,
              text: messageData.content,
              senderType: SenderType.LiveAgent,
              receiverType: SenderType.Contact,
              attachments: messageData.attachments,
              messageId: uuid.v4(),
              liveAgentAvatar:messageData?.performer?.avatar_url,
              liveAgentName:  messageData?.performer?.available_name
            });
            NotificationCount.value++;
            ChatCommandCommunication({ command: "ResponseReceived",count:NotificationCount.value });
          }
        }
          
         } catch {
           data.value = event.data
           EventBus.emit('message', event.data)
         }
       }
 
       // Handle connection close
       socket.value.onclose = (event) => {
         isSocketConnected.value = false
         EventBus.emit('close', event)
         
         if (!event.wasClean && currentReconnectAttempt < reconnectAttempts) {
           currentReconnectAttempt++
          //  console.log(`WebSocket disconnected. Attempting to reconnect (${currentReconnectAttempt}/${reconnectAttempts})`)
           
           setTimeout(() => {
            socketConnect(options)
           }, reconnectTimeout)
         }
       }
 
       // Handle errors
       socket.value.onerror = (err) => {
         error.value = new Error('WebSocket error')
         EventBus.emit('error', err)
         console.error('WebSocket error:', err)
       }
     } catch (err) {
       error.value = err instanceof Error ? err : new Error(String(err))
       EventBus.emit('error', err)
       console.error('Failed to connect WebSocket:', err)
     }
   }
 
   // Send message method
   function socketSend(message: string | object) {
     if (isSocketConnected.value && socket.value) {
       const formattedMessage =  message
       try
       {
        socket.value.send(formattedMessage)
       }
       catch(e)
       {
        setTimeout(() => {
          socketSend(formattedMessage)
        }, 2000);
       }
    
     } else {
       console.warn('Cannot send message. WebSocket is not connected.')
     }
   }
 
   // Close connection method
   function socketClose() {
     if (socket.value) {
       socket.value.close()
       socket.value = null
       isSocketConnected.value = false
     }
   }
 
  //#endregion
   
   return{
    ChatMessageDetails,
    LiveAgentChatMessageDetails,
    ClearChatDetails,
    ConversationId,
    ChatNewSessionId,
    ChatOldSessionId,
    ChatCallFrom,
    ChatLiveAgentDetails,
    ContactDetails,
    ConversationDetails,
    socket,
    socketConnect,
    socketClose,
    socketSend,
    isSocketConnected,
    DomSnapBase64Image
   }
},
{
  persist: {
    storage: localStorage,
  },
}
)